// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"940d2256","264":"8fee3273","521":"1dfa685c","803":"474119be","854":"1e7220b4","998":"72cff32b"}[chunkId] + ".chunk.css";
};